export const workedStatusList = [
  {
    name: "Assigned",
    value: "assigned",
  },
  {
    name: "Authorised",
    value: "authorized",
  },
  {
    name: "Invoiced",
    value: "invoiced",
  },
  {
    name: "Pending",
    value: "pending",
  },
  {
    name: "Terminated",
    value: "terminated",
  },
  {
    name: "Rejected",
    value: "rejected",
  },
];

export const complianceFilterList = [
  {
    name: "0% - 25%",
    value: "0-25",
    cls: "!bg-miles_six_bg !text-miles_six_color",
  },
  {
    name: "26% - 50%",
    value: "26-50",
    cls: "!bg-miles_five_bg !text-miles_five_color",
  },

  {
    name: "51% - 75%",
    value: "51-75",
    cls: "!bg-miles_four_bg !text-miles_four_color",
  },

  {
    name: "76% - 100%",
    value: "76-100",
    cls: "!bg-miles_two_bg !text-miles_two_color",
  },
];

export const sessionTypeList = [
  {
    name: "Preferred",
    value: "preferred",
  },
  {
    name: "No Status",
    value: "no_status",
  },
  {
    name: "Unsuitable",
    value: "unsuitable",
  },
];

export const invoiceStatusList = [
  {
    name: "Overdue",
    value: "overdue",
  },
  {
    name: "Paid",
    value: "paid",
  },
  {
    name: "Processing",
    value: "processing",
  },
];

export const CandidatePayInvoiceStatusList = [
  {
    name: "Pending",
    value: "Pending",
  },
  {
    name: "Processing",
    value: "Client Invoiced",
  },
  {
    name: "Paid",
    value: "Paid",
  },
];

export const milesList = [
  {
    name: "0 to 3 Miles",
    value: "0-3",
    cls: "!bg-miles_one_bg !text-miles_one_color",
  },
  {
    name: "3 to 6 Miles",
    value: "3-6",
    cls: "!bg-miles_two_bg !text-miles_two_color",
  },
  {
    name: "6 to 9 Miles",
    value: "6-9",
    cls: "!bg-miles_three_bg !text-miles_three_color",
  },
  {
    name: "9 to 12 Miles",
    value: "9-12",
    cls: "!bg-miles_four_bg !text-miles_four_color",
  },
  {
    name: "12 to 18 Miles",
    value: "12-18",
    cls: "!bg-miles_five_bg !text-miles_five_color",
  },
  {
    name: "18 to 24 Miles",
    value: "18-24",
    cls: "!bg-miles_six_bg !text-miles_six_color",
  },
  {
    name: ">24 Miles",
    value: "24+",
    cls: "!bg-miles_seven_bg !text-miles_seven_color",
  },
];

export const terminatedByList = [
  {
    name: "Client",
    value: "client",
  },
  {
    name: "Candidate",
    value: "candidate",
  },
  {
    name: "Consultant",
    value: "consultant",
  },
];

export const terminatedReasonsList = [
  {
    name: "Authorised Absense",
    value: "Authorised Absence",
  },
  {
    name: "Unauthorised Absense",
    value: "Unauthorised Absence",
  },
  {
    name: "Illness",
    value: "Illness",
  },
  {
    name: "Holiday",
    value: "Holiday",
  },
  {
    name: "Candidate Did Not Work",
    value: "Candidate Did Not Work",
  },
  {
    name: "Client Cancelled - Candidate Available",
    value: "Client Cancelled",
  },
  {
    name: "Candidate Cancelled - Client Available",
    value: "Candidate Cancelled",
  },
  {
    name: "Duplicate Timesheet - Eclipse",
    value: "Duplicate Timesheet - Eclipse",
  },
];

export const unfilledContractStatus = [
  {
    name: "Active",
    value: "active",
  },
  {
    name: "Archived",
    value: "archived",
  },
];
